import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormResponseSearchDto } from 'src/app/forms/shared/model/form-response-search.dto';

@Component({
  selector: 'wl-form-submission-search-params',
  templateUrl: './form-submission-search-params.component.html',
  styleUrls: ['./form-submission-search-params.component.less'],
    standalone: false
})
export class FormSubmissionSearchParamsComponent implements OnInit {
  @Input()
  get searchParams() {
    return this._searchParams;
  }
  set searchParams(value: FormResponseSearchDto) {
    this._searchParams = value;
    this.searchParamsChange.emit(this._searchParams);
  }
  @Output() searchParamsChange: EventEmitter<FormResponseSearchDto> = new EventEmitter();

  private _searchParams = new FormResponseSearchDto();
  constructor() {}

  ngOnInit(): void {}
}
